<template>
  <div>
    <h3 class="section-title section-title--small">View on map</h3>
    <hr aria-hidden="true" class="devider" />
    <GoogleMap />
    <Tags />
  </div>
</template>

<script>
import { mapState } from "vuex";
import { mapState, mapMutations } from "vuex";
import GoogleMap from "../components/GoogleMap";
import Tags from "../components/product-page/Tags";
export default {
  name: "ProductPAge",
  components: {
    GoogleMap,
    Tags,
  },
  computed: {
    ...mapState("map", ["isMapOpen"]),
  },
  methods: {
    ...mapMutations("map", ["setCord", "setRadius"]),
    ...mapMutations("products", ["setTags"]),
  },
  created() {
    this.setCord(window.cord);
    this.setTags(window.tags);
    this.setRadius(window.radius);
  },
};
</script>
